import React from 'react'

import { Link } from '@factorialco/deprecated-design-system'
import { EnvironmentContext } from 'config/environment'
import { BankingValueObjectsOnboardingCreationSourceValueEnum } from 'generated/resources/graphql'

import { track } from 'modules/core/lib/Tracking'

import { getAccountUrl } from 'modules/banking/components/AccountOnboarding/utils'

interface AccountOnboardingLinkProps {
  label: string
  source: BankingValueObjectsOnboardingCreationSourceValueEnum
  legalEntityId?: number
  trackingEvent?: string
}

const AccountOnboardingLink = ({
  label,
  source,
  legalEntityId,
  trackingEvent
}: AccountOnboardingLinkProps) => {
  const environment = React.useContext(EnvironmentContext)

  const handleOnClick = () => {
    if (trackingEvent) {
      track(trackingEvent)
    }
  }

  return (
    <Link.Href href={getAccountUrl(environment, source, legalEntityId)} onClick={handleOnClick}>
      {label}
    </Link.Href>
  )
}

export default AccountOnboardingLink
